import { Eye, Layers3, Rotate3D } from 'lucide-react'

const modes = [
  ['assembled', '整机', Rotate3D],
  ['exploded', '爆炸', Layers3],
  ['xray', '透视', Eye],
]

export default function ViewerControls({ value, onChange, visible }) {
  return (
    <div
      className={`viewer-controls ${visible ? 'viewer-controls--visible' : ''}`}
      role="group"
      aria-label="模型显示模式"
    >
      {modes.map(([mode, label, Icon]) => (
        <button
          key={mode}
          type="button"
          className={value === mode ? 'is-active' : ''}
          aria-pressed={value === mode}
          title={`${label}模式`}
          onClick={() => onChange(mode)}
        >
          <Icon aria-hidden="true" />
          <span>{label}</span>
        </button>
      ))}
    </div>
  )
}
